import { H1, HStack, Text, VStack } from '@betterment/samba-react';

import { ForEmployees } from './ForEmployees';
import { ForPlanSponsors } from './ForPlanSponsors';

import { ApplicationLayout } from '../layout/ApplicationLayout';

/**
 * Resources page component for the SPA.
 * Renders educational resources for plan sponsors and employees.
 */
export const ResourcesPage = () => {
  return (
    <ApplicationLayout pageTitle="Resources">
      <ApplicationLayout.Header>
        <VStack css={{ gap: 'space.100', alignItems: 'flex-start' }}>
          <H1 variant="title300">Resources</H1>
          <Text variant="text100">Tools to share with employees and make managing your plan easier.</Text>
        </VStack>
      </ApplicationLayout.Header>
      <ApplicationLayout.Content>
        <HStack css={{ alignItems: 'flex-start', gap: 'space.400' }}>
          <ForEmployees />
          <ForPlanSponsors />
        </HStack>
      </ApplicationLayout.Content>
      <ApplicationLayout.Footer />
    </ApplicationLayout>
  );
};
